export function decreaseLatLongPrecision(latOrLong: number): number {
  return Number(latOrLong.toFixed(4));
}
